<!-- {{ 'saas-subscription.subscription-actions.view-features' | translate }} -->

<div
  style="
    font-size: 30px;
    font-weight: 700;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 6px;
  "
>
  <mat-card-title mat-dialog-title class="d-flex align-items-center mb-0 title">
    <mat-icon class="mr-2">clear_all</mat-icon>
    {{ 'Plan Overview' | translate }}
  </mat-card-title>
  <mat-card-subtitle class="mb-1 subtitle">{{
    'End user view of features' | translate
  }}</mat-card-subtitle>
  <mat-divider class="mb-4"></mat-divider>

  <mat-dialog-content>
    <div style="font-size: 30px; font-weight: 700">
      {{ this.plan?.name }} Plan
    </div>
    <div style="font-size: 16px; font-weight: 400; color: #92959c">
      {{ this.plan?.description }}
    </div>

    <div>
      <span *ngIf="priceDetails" style="font-size: 32px; font-weight: 700">
        {{ priceDetails }}
      </span>
      <span style="font-size: 16px; font-weight: 400">
        {{ planDetails }}
      </span>
    </div>

    <div
      style="
        font-size: 18px;
        font-weight: bold;
        margin-left: 5px;
        margin-top: 15px;
      "
    >
      {{ 'saas-subscription.user-view-popup.key-features' | translate }}
    </div>

    <div *ngIf="features?.length" style="margin-left: 15px">
      <div
        class="row align-items-center"
        style="margin-top: 5px"
        *ngFor="let singleFeat of features; let i = index"
      >
        <div class="col">
          <mat-icon style="vertical-align: top">
            {{ singleFeat?.icon }}
          </mat-icon>
          <span style="padding-left: 10px">
            {{ singleFeat?.name }}
          </span>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex justify-content-end mt-3">
    <button
      *ngIf="this.isPopup"
      mat-button
      class="m-2"
      [mat-dialog-close]="false"
    >
      {{ 'saas-subscription.subscription-actions.close' | translate }}
    </button>
  </mat-dialog-actions>
</div>
